import { getHtml } from "../apis/templateHtml";
import { getAllZone } from "../data/zodoData";
/**
 * ZO検索
 */
export const setSelectZo = async () => {
    // ZO名のドロップダウンリストを設定
    const inputZoName = document.getElementById('inputZoName');
    if (inputZoName) {
        inputZoName.innerHTML = userZoSelect("", false);
        console.log('ZO名のドロップダウンリストを設定しました');
    }
    else {
        console.error('inputZoName要素が見つかりません');
    }
};
/**
 * ZO検索
 */
export const setSearchZo = async () => {
    // ZO検索のHTMLを取得
    const searchZoModal = document.getElementById('searchZoModal');
    const searchZoModalContent = await getHtml("/parts/serachZo.html");
    if (searchZoModalContent) {
        searchZoModal.innerHTML = searchZoModalContent;
    }
    // ZO番号を取得
    const classSearchZoCode = document.querySelector('.js-search-zo-code');
    // 開くボタンの実装
    if (classSearchZoCode) {
        classSearchZoCode.addEventListener('click', () => {
            searchZoModal?.classList.add('is-active');
        });
    }
    // ZO名を取得
    const classSearchZoName = document.querySelector('.js-search-zo-name');
    // 開くボタンの実装
    if (classSearchZoName) {
        classSearchZoName.addEventListener('click', () => {
            searchZoModal?.classList.add('is-active');
        });
    }
    //「閉じるボタン」をクリックしてモーダルを閉じる
    const closeSearchZoModal = document.querySelector('.js-search-zo-modal-close');
    if (closeSearchZoModal) {
        closeSearchZoModal.addEventListener('click', () => {
            searchZoModal.classList.remove('is-active');
        });
    }
    //「モーダルの外側」をクリックしてモーダルを閉じる
    function modalOut(e) {
        if (e.target === searchZoModal) {
            searchZoModal?.classList.remove('is-active');
        }
    }
    addEventListener('click', modalOut);
    const zoCondition = document.getElementById('zoCondition');
    if (zoCondition) {
        zoCondition.innerHTML = userZoButton("");
    }
    const searchZoInput = document.getElementById('searchZoInput');
    if (searchZoInput) {
        searchZoInput.addEventListener('keyup', () => {
            zoCondition.innerHTML = userZoButton(searchZoInput.value);
        });
    }
};
function userZoButton(searchWord) {
    let zoList = "";
    let zoCode = "";
    let zoName = "";
    const zoneData = {
        zone: getAllZone(),
    };
    for (let key in zoneData.zone.zone_data) {
        zoCode = zoneData.zone.zone_data[key].zone_code;
        zoName = zoneData.zone.zone_data[key].zone_name;
        if (searchWord === "" || zoCode.match(searchWord) || zoName.match(searchWord)) {
            zoList +=
                '<button class="selectButton" type="button" onClick="inputZoCode.value = \'' + zoCode + '\'; inputZoName.value = \'' + zoName + '\'; searchZoModal.classList.remove(\'is-active\');">' + zoCode + '：' + zoName + '</button>';
        }
    }
    return zoList;
}
function userZoSelect(searchWord, isCode) {
    let zoList = '<option value="">選択してください</option>';
    let zoCode = "";
    let zoName = "";
    const zoneData = {
        zone: getAllZone(),
    };
    for (let key in zoneData.zone.zone_data) {
        zoCode = zoneData.zone.zone_data[key].zone_code;
        zoName = zoneData.zone.zone_data[key].zone_name;
        if (searchWord === "" || zoCode.match(searchWord) || zoName.match(searchWord)) {
            if (isCode) {
                zoList +=
                    '<option value="' + zoCode + '">' + zoCode + '</option>';
            }
            else {
                zoList +=
                    '<option value="' + zoName + '">' + zoName + '</option>';
            }
        }
    }
    return zoList;
}
